import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('appStore', () => {
  const isLoading = ref(false)
  const message = ref('')

  const isMessageShow = computed(() => message.value !== '')

  const startLoad = () => { isLoading.value = true }

  const stopLoad = () => { isLoading.value = false }

  const showMessage = async (msg, timeout = 2000) => {
    message.value = msg
    await new Promise((resolve) => { setTimeout(resolve, timeout) })
    message.value = ''
  }

  const hideMessage = () => { message.value = '' }

  return {
    isLoading,
    message,
    isMessageShow,
    startLoad,
    stopLoad,
    showMessage,
    hideMessage,
  }
})
